import { render, staticRenderFns } from "./ViewHeader.vue?vue&type=template&id=6be90b92&scoped=true&"
import script from "./ViewHeader.vue?vue&type=script&lang=js&"
export * from "./ViewHeader.vue?vue&type=script&lang=js&"
import style0 from "./ViewHeader.vue?vue&type=style&index=0&id=6be90b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be90b92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDivider,VIcon,VImg})
